import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ErrorImg from "../../assests/404.png";
import SEO from '../../component/util/SEO';
import 'bootstrap/dist/css/bootstrap.min.css';
import './nopagefound.css'

function NoPageFound() {
    const { t } = useTranslation();
    return (
        <main style={{ background: "black", minHeight: '97.5vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} aria-labelledby="not-found-heading">
            <SEO
                title="Page Not Found"
                description="The requested BringIt Go page could not be found."
                canonical="https://www.bringitgo.tech/404"
                robots="noindex, follow"
            />
            <Row className='d-flex justify-content-center'>
                <Col xs="auto">
                    <img className='error-code' src={ErrorImg} alt='404 page not found illustration' width={320} height={240} />
                </Col>
            </Row>
            <Row className='d-flex justify-content-center mt-3'>
                <Col xs="auto" className='text-center'>
                    <h1 id="not-found-heading" className='text-light'>{t('notFound.heading')}</h1>
                    <p className='text-secondary'>{t('notFound.description')}</p>
                    <a href="/" className='btn btn-light mt-3'>{t('notFound.backButton')}</a>
                </Col>
            </Row>
        </main>

    )
}

export default NoPageFound
